import { Component } from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';
import { ToastPositionService } from './shared/services/toast-position.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { SecurityService } from './shared/services/security.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
   toastaPosition: string;
  constructor(private toastCommunicationService: ToastPositionService
    , private bnIdle: BnNgIdleService
    , private securityService: SecurityService
    , private _router: Router) {
    setTheme('bs3'); // or 'bs4'
    this.toastCommunicationService.position$.subscribe(pos => this.toastaPosition = pos);
  }
  ngOnInit(): void {
    this.bnIdle.startWatching(600).subscribe((isTimedOut: boolean) => {
      //  if (isTimedOut) {
      //    if (this._router.url != '/login') {
      //     this.securityService.Logoff()
      //    }
      //  }
    });
  }
}
